import React, { useState } from 'react'

import { DefaultTooltip } from 'twyne-new.ui'

export default function TipTapTooltip({ children, content }) {
  const [tooltipOpen, setTooltipOpen] = useState(false)

  return <div onMouseEnter={() => setTooltipOpen(true)} onMouseLeave={() => setTooltipOpen(false)}>
    <DefaultTooltip content={content} triggerProps={{ asChild: true }} open={tooltipOpen}>
      {children}
    </DefaultTooltip>
  </div>
}
